import axiosInstance from '../../Config/axiosConfig';

export const getSubscriptionPlans = async () => {
  try {
    const response = await axiosInstance.get('/user/plans');
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const createPaymentIntent = async (amount) => {
  try {
    const response = await axiosInstance.post('/user/payment-intent', {
      amount: amount
    });
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const subscribeToPlans = async (planSlug, paymentIntentId) => {
  try {
    const response = await axiosInstance.post('/user/subscribe', {
      plan_slug: planSlug,
      payment_intent_id: paymentIntentId
    });
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getSubscriptionLogs = async () => {
  try {
    const response = await axiosInstance.get('/user/subscription/logs');
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};